import { debounce} from './functions.js';
		
export default function KeepScrollModule(element) {

    let target = element.getAttribute('kd-target') === 'window'
                    ? window
                    : element;

    let axis = element.getAttribute('kd-axis') || 'y';

    let scrollProperty = 'saveScrollPos_' + element.getAttribute('kd-identifier');

    let onScroll = debounce(function() {
        if (target === window && axis === 'y') {
            window.sessionStorage[scrollProperty] = target.scrollY;
        } else if (target === window && axis === 'x') {
            window.sessionStorage[scrollProperty] = target.scrollX;
        } else if (axis === 'y') {
            window.sessionStorage[scrollProperty] = target.scrollTop;
        } else {
            window.sessionStorage[scrollProperty] = target.scrollLeft
        }
    }, 200);

    target.addEventListener('scroll', onScroll);

    function onLoad() {
        let value = window.sessionStorage[scrollProperty];
        if (value) {
            setTimeout(function() {
                if (axis === 'y') {
                    target.scrollTo(0, value)
                } else {
                    target.scrollTo(value, 0)
                }
                hideVeil();
            }, 200);
        } else {
            hideVeil();
        }
    };

    function hideVeil() {
        if (target !== window) return;
        window.hideVeil();
    }

    onLoad();

    return this;
}